import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-arrow-square-right',
  imports: [],
  templateUrl: './icon-arrow-square-right.component.html',
})
export class IconArrowSquareRightComponent {
  @Input() color: string = '#171717';
  @Input() size: string = '24px';
}
